import React from 'react'
import { FiChevronRight, FiChevronDown } from 'react-icons/fi'
import { fieldList } from './mock'

export const Fields = () => {
    const [show,setShow] = React.useState(true)
    const handleShow = (e) => {
        e.preventDefault();
        setShow(!show);
    }
 
    return (
        <div className="fields">
            <ul>
             

                {
                    fieldList.map((item,i)=>(
                        <li  onClick={(e)=>handleShow(e)}>
                            <div>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>

                            <div className="setting">
                                {!show ? <FiChevronRight />: <FiChevronDown /> }
                            </div>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}
 